<template>
    <Header />

    <section class="orbital vv-main" data-barba="container" data-barba-namespace="orbital">
        <swiper class="videoSwiper" :navigation="true" :modules="modules">
            <template v-for="video in videos">
                <swiper-slide>
                    <video controls autoplay :poster="video.thumb ? video.thumb.url : ''">
                        <template v-for="format in video.formats.data">
                            <source :src="format.url" :type="format.type">
                        </template>
                        Your browser does not support the video tag.
                    </video>
                </swiper-slide>
            </template>
        </swiper>
    </section>
</template>

<script>
import Header from "../components/Header"
import Axios from "axios";

import {Swiper, SwiperSlide} from 'swiper/vue';
import { Navigation } from "swiper";

import 'swiper/css';
import "swiper/css/navigation";

export default {
    beforeMount() {
        Axios.get(process.env.MIX_APP_URL + '/domain?include=settings,files,videos,videos.formats,videos.thumb,tours,tours.thumb').then((response) => {
            this.domain = response.data.data;

            if(!this.withMenu) {
                this.$router.push({name: 'orbital-show'});
            }

            if(!this.$cookies.isKey('promptCookie') && this.withModal) {
                this.$store.dispatch('modals/open', 'prompt-modal')
            }

            Axios.get(`${window.location.origin}/storage/cyclorama/${this.domain.name.toLowerCase()}/tour.xml`).then( (file) => {
                this.isCycloramaAvailable = file.headers['content-type'] === 'application/xml; charset=utf-8';
            })

            Axios.get(`${window.location.origin}/storage/vtour/${this.domain.name.toLowerCase()}/1/tour.xml`).then( (file) => {
                this.isVirtualTourAvailable = file.headers['content-type'] === 'application/xml; charset=utf-8';
            })
        })

        window.addEventListener('resize', this.onResize);
    },
    data() {
        return {
            isMenuOpen: false,
            domain: null,
            windowWidth: window.innerWidth,
            isCycloramaAvailable: false,
            isVirtualTourAvailable: false,
            modules: [Navigation],
        }
    },
    computed: {
        videos() {
            if (this.domain) {
                return this.domain.videos.data
            }

            return null
        },
        withMenu() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-menu' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-menu' ).value)
            }

            return false
        },
        withModal() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-modal' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-modal' ).value)
            }

            return false
        }
    },
    methods: {
        onSwiper(swiper) {
        },
        onSlideChange() {
        }
    },
    components: {
        Header,
        Swiper,
        SwiperSlide,
    }
}
</script>

<style>
    .videoSwiper {
        width: 100%;
        height: 100%;
    }

    .videoSwiper video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .videoSwiper > .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }

    .videoSwiper > .swiper-slide video {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .videoSwiper > .swiper-button-prev, .swiper-button-next {
        z-index: 100;
        background-color: transparent;
        color: var(--base-color);
    }
</style>
